module.exports = __webpack_public_path__ + "img/icon-dept.2ed117a7.png";